export default "__VITE_ASSET__UxHr6qY4__"